// Compatibility layer for asset fields on Algolia records. The index is being
// reworked to store assets as compact strings instead of objects (to shrink
// record — and ultimately __NEXT_DATA__ — size), and both shapes coexist
// while it rolls out. Hits are kept raw through the SWR cache and the
// serialized swrFallback; parseAlgoliaAsset expands assets at render time.
//
// Old shape: { url, dimensions?: { width, height }, imageToEdge?: true }
// New shape: "<path>#<W>x<H>,ie" where
//   - a path starting with "blt" is a Contentstack asset path with
//     ASSET_URL_PREFIX stripped; any other path is stored verbatim
//   - the "#" fragment is optional, as is each comma-separated part of it:
//     "WxH" carries the dimensions, "ie" marks imageToEdge

const ASSET_URL_PREFIX = 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/'

const DIMENSIONS_TAG = /^(\d+)x(\d+)$/

export interface AlgoliaAssetObject {
  dimensions?: {
    height: number
    width: number
  }
  imageToEdge?: boolean
  url: string
}

export type AlgoliaAsset = AlgoliaAssetObject | string

export function parseAlgoliaAsset(asset: AlgoliaAsset | null | undefined): AlgoliaAssetObject | undefined {
  if (asset == null) {
    return undefined
  }

  if (typeof asset !== 'string') {
    // old records store missing assets as objects with an empty url; the new
    // format just omits them — normalize to absent so both shapes agree
    return asset.url ? asset : undefined
  }

  const [path, fragment] = asset.split('#')
  if (!path) {
    return undefined
  }

  const out: AlgoliaAssetObject = {
    url: path.startsWith('blt') ? ASSET_URL_PREFIX + path : path,
  }

  fragment?.split(',').forEach((tag) => {
    if (tag === 'ie') {
      out.imageToEdge = true
    }

    const dimensions = DIMENSIONS_TAG.exec(tag)
    if (dimensions) {
      out.dimensions = {
        height: Number(dimensions[2]),
        width: Number(dimensions[1]),
      }
    }
  })

  return out
}
